import { render } from "./PrintTempSelect.vue?vue&type=template&id=01204ce1&ts=true"
import script from "./PrintTempSelect.vue?vue&type=script&lang=ts"
export * from "./PrintTempSelect.vue?vue&type=script&lang=ts"

import "./PrintTempSelect.vue?vue&type=style&index=0&id=01204ce1&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__